import GiftWrapOffer from './GiftWrapOffer';

export default GiftWrapOffer;
